<template>
  <custom-dialog :visible="visible" width="512px" class="invoice-apply-dialog" :title="model.title" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <div class="input-container">
        <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
          <el-form-item :label="$t('invoice_apply_dialog.fa_piao_jin_e')">
            <el-input type="text" v-model="invoiceAmount" placeholder="" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('invoice_apply_dialog.fa_piao_lei_xing')" prop="invoiceTypeValue" :rules="rules.invoiceTypeValue">
            <invoice-type-select
              v-model="form.invoiceTypeValue"
              ref="invoiceTypeSelect"
              @change="updateTypeAndClassByValue(form, $event)"
              @init="initTypeAndClassByValue(form, $event)"
              :placeholder="$t('Common.com_please_select')"
            ></invoice-type-select>
          </el-form-item>
          <el-form-item :label="$t('invoice_apply_dialog.fa_piao_tai_tou')" prop="partnerInvoiceId" :rules="rules.partnerInvoiceId" class="last-row">
            <custom-select
              v-model="form.partnerInvoiceId"
              :fullUrl="fullUrl"
              :props="{ label: 'buyerName', value: 'partnerInvoiceId' }"
              width="100%"
              @change="onTitleChange"
              ref="partnerInvoiceId"
            ></custom-select>
            <div class="add-invoice" @click="addBodyItem">
              <i class="icon icon-add2"></i>
              <span class="label">{{ $t('invoice_apply_dialog.fa_piao_tai_tou') }}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="msg-content" v-if="form.partnerInvoiceId">
        <div class="title">{{ $t('invoice_apply_dialog.fpttxq') }}</div>
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.shui_hao') }}</div>
            <div class="val">{{ form.buyerNumber }}</div>
          </li>
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.ming_cheng') }}</div>
            <div class="val">{{ form.buyerName }}</div>
          </li>
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.dan_wei_di_zhi') }}</div>
            <div class="val">{{ form.buyerRegisterAddress }}</div>
          </li>
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.dian_hua_hao_ma') }}</div>
            <div class="val">{{ form.buyerMobile }}</div>
          </li>
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.kai_hu_yin_hang') }}</div>
            <div class="val">{{ form.buyerDepositBank }}</div>
          </li>
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.yin_hang_zhang_hao') }}</div>
            <div class="val">{{ form.buyerDepositNumber }}</div>
          </li>
          <li>
            <div class="key">{{ $t('invoice_apply_dialog.you_xiang') }}</div>
            <div class="val">{{ form.buyerEmail }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="warning" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <body-item-dialog v-if="bodyItemVisible" @close="bodyItemVisible = false" :model="bodyItemModel" @success="onSuccess"></body-item-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import invoiceTypeSelect from '@/components/invoiceTypeSelect.vue';
import invoiceTypeMixins from '@/utils/invoice_type_mixins.js';
import bodyItemDialog from './body_item_dialog';

export default {
  mixins: [dialogMixins, invoiceTypeMixins],
  components: { bodyItemDialog, invoiceTypeSelect },
  data() {
    return {
      form: {
        invoiceAmount: '',
        invoiceType: '',
        invoiceClass: '',
        invoiceTypeValue: '',
        partnerInvoiceId: '',
        buyerNumber: '',
        buyerName: '',
        buyerEmail: '',
      },
      bodyItemVisible: false,
      bodyItemModel: {},
      fullUrl: '',
    };
  },
  computed: {
    rules() {
      return {
        invoiceTypeValue: [
          {
            required: true,
            message: this.$t('invoice_apply_dialog.fplxbx'),
          },
        ],
        partnerInvoiceId: [
          {
            required: true,
            message: this.$t('invoice_apply_dialog.fpttbx'),
          },
        ],
      };
    },
    invoiceAmount: function () {
      const list = Array.isArray(this.model.row) ? [...this.model.row] : [this.model.row];
      return list.reduce((total, item) => {
        const { paymentAmount = 0, breakAmount = 0, overdueAmount = 0, depositFee = 0 } = item;
        const sum = paymentAmount + breakAmount + overdueAmount + depositFee;
        return sum + total;
      }, 0);
    },
  },
  mounted: function () {
    const list = Array.isArray(this.model.row) ? [...this.model.row] : [this.model.row];
    const item = list[0];
    this.fullUrl = `${apis.crmPartnerInvoiceList}/${item.payableOrgId}`;
    this.getCompDictionary();
  },
  methods: {
    onSuccess() {
      this.$refs.partnerInvoiceId.getSelectList();
    },
    addBodyItem() {
      this.bodyItemModel = {
        type: 'add',
        title: this.$t('invoice_apply_dialog.xzfptt'),
      };
      this.bodyItemVisible = true;
    },
    onAddSuccess() {
      this.$refs.partnerInvoiceId.getSelectList();
    },
    onTitleChange(item) {
      this.form.buyerNumber = item.buyerNumber;
      this.form.buyerName = item.buyerName;
      this.form.buyerRegisterAddress = item.buyerRegisterAddress;
      this.form.buyerMobile = item.buyerMobile;
      this.form.buyerDepositBank = item.buyerDepositBank;
      this.form.buyerDepositNumber = item.buyerDepositNumber;
      this.form.buyerEmail = item.buyerEmail;
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          const rows = Array.isArray(this.model.row) ? [...this.model.row] : [this.model.row];
          // const tips = '您确定要为选中的账单进行开票吗？';

          // this.$showConfirm(this, tips).then(() => {
          const billIdList = rows.map(item => item.billId);
          this.form.billIdList = billIdList;
          this.$postJSON(apis.invoiceMark, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.$emit('success');
            this.closeDialog();
          });
          // });
        }
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.invoice-apply-dialog {
  .last-row {
    margin-bottom: 0 !important;
    position: relative;

    .el-form-item__label {
      position: relative;
      z-index: 0;
    }

    .add-invoice {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .icon {
        float: left;
        font-size: 10px;
        $scale: 10 / 12;
        transform: scale($scale);
      }
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
      }
    }
  }
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    .msg-content {
      margin-top: 8px;
      padding: 14px;
      border: 1px solid rgba(240, 240, 240, 1);
      border-radius: 8px;
      margin-bottom: 14px;
      .title {
        line-height: 17px;
        color: #818181;
        font-weight: bold;
        font-size: 12px;
      }
      .msg-list {
        margin-top: 6px;
        > li {
          overflow: hidden;
          margin-top: 8px;
          line-height: 17px;
          font-size: 12px;
          .key {
            float: left;
            color: #4d4d4d;
            font-weight: bold;
          }
          .val {
            overflow: hidden;
            padding-left: 16px;
            color: #1a1a1a;
            font-weight: bold;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      background: #fff;
    }
  }
}
</style>
